import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
  subTitle: {
    marginBottom: 20,
    fontSize: 14,
    fontWeight: 500,
  },
});
